export const allColors = {
  akaroa: '#cbc98f',
  alizarin: '#e72326',
  amber: '#f4c401',
  amethyst: '#8e57b3',
  aqua: '#10e4fe',
  astralBlue: '#2f7ca2',
  ateneoBlue: '#0d466a',
  avocado: '#81b12f',
  azure: '#108cf7',
  baliHai: '#8498b6',
  bermudaGrey: '#7488A4',
  biscay: '#334154',
  black: '#000',
  blackPearl: '#141B24',
  blueBayoux: '#4f5e74',
  blueMagenta: '#542f9d',
  blueRibbon: '#0b35ff',
  blueYonder: '#586fd2',
  bouqet: '#a35c9a',
  brick: '#c62828',
  brightOrange: '#f29c22',
  brown: '#785349',
  candyCorn: '#fcef4d',
  carnation: '#ff8adf',
  carrot: '#f29a2d',
  cerise: '#d52a96',
  cerulean: '#008b9e',
  chantilly: '#f7b0eb',
  charcoal: '#474b4b',
  charcoalBlue: '#334154 ',
  chartreuse: '#34ff01',
  chatamsBlue: '#2A496B',
  clay: '#283243',
  cloudBurst: '#333D4C',
  cocoaBean: '#5c1200',
  coffeeBean: '#321014',
  coolGray: '#8593B3',
  comet: '#5a6982',
  cornflower: '#2060ff',
  crimson: '#e53126',
  curiousBlue: '#178ee0',
  cyan: '#0cf',
  darkFontColor: '#0d151d',
  darkGray: '#333',
  darkPurple: '#6f3eae',
  darkRed: '#b30000',
  defaultFontColor: '#bbbfc5',
  deepTeal: '#003D27',
  dodgerBlue: '#1774ff',
  eagleGreen: '#005557',
  ebony: '#101a26',
  eggplant: '#7a0074',
  electricGreen: '#00ff0a',
  emerald: '#09c199',
  espresso: '#5a3627',
  fieldPromptError: '#fd9693',
  fieldPromptInfo: '#00bfff',
  fireEngineRed: '#c21d20',
  flamingo: '#f861b6',
  flirt: '#910870',
  forestGreen: '#1f7f1f',
  geraldine: '#fe9486',
  grannysmith: '#92e959',
  green: '#4caf50',
  goldenBrown: '#80670c',
  gunmetalBlue: '#344152',
  harlequin: '#20cb00',
  harvestGold: '#e6c079',
  hemlock: '#626740',
  imperial: '#4b0134',
  independence: '#4A5669',
  iron: '#d9dee0',
  japaneseIndigo: '#264359',
  juniper: '#6d9292',
  jungleGreen: '#087950',
  khaki: '#bba44b',
  koamaru: '#2f346a',
  korma: '#90370e',
  lavender: '#B086E3',
  lavenderRose: '#fb9fda',
  lightGray: '#eee',
  lightPurple: '#b43be4',
  lilac: '#a195d4',
  lincolnGreen: '#254600',
  magenta: '#ff15e0',
  malibu: '#68C2FB',
  mantis: '#4fa83d',
  maroon: '#ad3349',
  mauve: '#e06cfb',
  mediumGray: '#999',
  midFontColor: '#8593b3',
  midnight: '#233346',
  midnightBlue: '#1A2736',
  mint: '#3ac999',
  mintGreen: '#15b77d',
  mirage: '#182432',
  mulberry: '#5c0536',
  olive: '#807300',
  oliveBrown: '#463703',
  orange: '#ff7200',
  orchid: '#ab00ff',
  oxfordBlue: '#384558',
  pacific: '#00b5b6',
  pakistanGreen: '#006e00',
  portGore: '#394c6b',
  palm: '#1aa511',
  persian: '#1717cf',
  persianLight: '#0327ce',
  pewterBlue: '#92a8c2',
  pine: '#017074',
  pink: '#f74f8a',
  pistachio: '#aac609',
  raspberry: '#990030',
  red: '#f95359',
  reddishPink: '#CE6068',
  regalBlue: '#1D354E',
  robinsEggBlue: '#00bcd4',
  romanSilver: '#7d888d',
  salem: '#03832e',
  sanguineRed: '#68252A',
  sapGreen: '#5f7e20',
  seaGreen: '#0b8a51',
  seance: '#7f1f82',
  shiraz: '#c61021',
  sinopia: '#D14200',
  summerSky: '#36A1EA',
  spindle: '#bcc7da',
  tangerine: '#ff9900',
  teal: '#008285',
  toast: '#997862',
  trueBlue: '#066CC6',
  turquoise: '#00b5b6',
  vermilion: '#b95555',
  viking: '#59cfe0',
  violet: '#3e4eb8',
  violetBlue: '#8060d2',
  vividAzure: '#198BDC ',
  walnut: '#783f00',
  white: '#fff',
  whiteSmoke: '#f8f8f8',
  windsorTan: '#b35c00',
  yellow: '#ffca28',
  yellowOrange: '#fa3',
  zucchini: '#016422',
  get hiliteFontColor() {
    return this.white;
  },
  get lightFontColor() {
    return this.lightGray;
  },
  get borderColor() {
    return this.lightGray;
  },
  get actionColor() {
    return this.midFontColor;
  },
  get backgroundColor() {
    return this.mirage;
  },
} as const;

export type ColorName = keyof typeof allColors;

/**
 * Given an array of valid color names, return an array containing their hex values as strings.
 */
function returnColorPalette(colorNames: ColorName[]): string[] {
  return colorNames.map((name) => allColors[name]);
}

// Base Colors
export const baseColors = returnColorPalette([
  'curiousBlue',
  'robinsEggBlue',
  'green',
  'yellow',
  'red',
  'white',
  'black',
]);

// Layout Colors
export const layoutColors = returnColorPalette([
  'ebony',
  'mirage',
  'clay',
  'oxfordBlue',
  'blueBayoux',
  'comet',
  'baliHai',
]);

// Grays
export const grayColors = returnColorPalette(['darkGray', 'mediumGray', 'lightGray', 'iron']);

// Font Colors
export const fontColors = returnColorPalette([
  'darkFontColor',
  'hiliteFontColor',
  'lightFontColor',
  'defaultFontColor',
  'midFontColor',
]);

// Button Palette
export const buttonColors = returnColorPalette([
  'turquoise',
  'violet',
  'emerald',
  'seaGreen',
  'avocado',
  'brick',
  'pink',
  'lightPurple',
  'charcoal',
]);

// New Button Palette
export const newButtonColors = returnColorPalette([
  'azure',
  'orchid',
  'tangerine',
  'palm',
  'magenta',
  'blueRibbon',
  'orange',
  'darkRed',
  'amber',
  'lilac',
  'pacific',
  'carnation',
  'brown',
  'khaki',
  'zucchini',
  'eggplant',
  //'crimson',
  'cerulean',
  'harlequin',
  'akaroa',
  'persianLight',
  'viking',
  'mauve',
  'espresso',
  'toast',
  'salem',
  'darkPurple',
  'cornflower',
  'grannysmith',
  'lavender',
]);

// Visualization Palette
export const vizColors = returnColorPalette([
  'aqua',
  'carrot',
  'flamingo',
  'dodgerBlue',
  'chantilly',
  'crimson',
  'candyCorn',
  'amethyst',
]);

export const vizColorsArray = returnColorPalette([
  'aqua',
  'carrot',
  'flamingo',
  'green',
  'dodgerBlue',
  'chantilly',
  'crimson',
  'candyCorn',
  'amethyst',
  'baliHai',
]);

// ODL Label Palette
export const fieldColors = returnColorPalette([
  'trueBlue',
  'eggplant',
  'sinopia',
  'forestGreen',
  'cerise',
  'persian',
  'teal',
  'violetBlue',
  'olive',
  'raspberry',
  'eagleGreen',
  'maroon',
  'brown',
  'windsorTan',
  'koamaru',
  'seance',
  'cocoaBean',
  'ateneoBlue',
  'sapGreen',
  'vermilion',
  'blueYonder',
  'korma',
  'hemlock',
  'imperial',
  'astralBlue',
  'shiraz',
  'blueMagenta',
  'flirt',
  'lincolnGreen',
  'bouqet',
]);
